import "../Price/Price.scss";
import TopHeader from "../../components/TopHeader/TopHeader";
import CheckRound from "../../assets/images/vactor/green-check-round.svg";
import { PrimaryButton } from "../../components/AllButtons/AllButtons";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { startPayment } from "../../Services/payment.service";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader/PaymentLoader/Loader";
import { useEffect } from "react";

const Price = () => {
  const {location} = useParams();
  const user = useAppSelector((state) => state.user);
  const loading = useAppSelector((state) => state.paymentLoader.loading);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user_id = user.uid;

  const handlePayment = () => {
    const requestBody = {
      user_id: user_id,
      plan_id: 35,
      currency: "USD",
    };

    dispatch(startPayment(requestBody))
      .unwrap()
      .then((response: any) => {
        const paymentUrl = response?.data?.payment_url;

        if (paymentUrl) {
          window.location.href = paymentUrl; // redirect to PayPal approval link
        }
      })
      .catch((error) => {
        console.error("Payment initiation failed:", error);
        // Optionally show a toast or dialog
      });
  };

  return (
    <>
      <TopHeader
        onMenuToggle={function (): void {
          throw new Error("Function not implemented.");
        }}
        onHistoryToggle={function (): void {
          throw new Error("Function not implemented.");
        }}
      />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div className="price-wrapper">
          {/* <div className="price-head-content">
            <h4 className="head-content-title">
              Unlock Your Learning Potential!
            </h4>
            <p className="head-content-dsc-text">
              Get personalized AI-driven learning, unlimited practice tests, and
              expert-guided lessons tailored to your learning style.
            </p>
          </div> */}
          <div className="test-result-wrapper">
            <div className="test-result-header pb-0">
              <div className="test-result-header-title blink-soft">
                Unlock Your {location === "chat" && "Result and"}  <br />Learning Potential!
              </div>
              {/* <div className="test-result-header-subtitle">
                Get personalized AI-driven learning, unlimited practice tests,
                and <br />
                expert-guided lessons tailored to your learning style.
              </div> */}
            </div>
          </div>

          <div className="price-plan-card-wrap">
            <div className="price-plan-card">
              <div className="price-card">
                <h4 className="plan-card-title">Student</h4>
                <p className="plan-card-dsc">Best for dedicated learners</p>
                <div className="plan-cate">
                  <span className="plan-cate-value">$10</span>
                  <span className="plan-cate-label">/month</span>
                </div>
                <div className="plan-summery-list">
                  {/* <div className="summery-list-items">
                    <div className="check-list">
                      <img src={CheckRound} alt="" />
                    </div>
                    <div className="list-items-text">
                      Unlimited access to all courses
                    </div>
                  </div> */}
                  <div className="summery-list-items">
                    <div className="check-list">
                      <img src={CheckRound} alt="" />
                    </div>
                    <div className="list-items-text">
                      Personal learning assistant
                    </div>
                  </div>
                  <div className="summery-list-items">
                    <div className="check-list">
                      <img src={CheckRound} alt="" />
                    </div>
                    <div className="list-items-text">
                      Progress tracking & certificates
                    </div>
                  </div>
                  <div className="summery-list-items">
                    <div className="check-list">
                      <img src={CheckRound} alt="" />
                    </div>
                    <div className="list-items-text">100 practice token</div>
                  </div>
                </div>
                <div className="price-plan-card-action">
                  <PrimaryButton
                    onClick={() => {
                      handlePayment();
                    }}
                  >
                    Choose Plan
                  </PrimaryButton>
                  <Link
                    to="/dashboard"
                    className="link-btn"
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Skip for now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Price;
